// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2405) return "static/chunks/2405-c23a355a031e4075.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1697":"b4d15ba0796b02cb","9270":"8d9cf56e9633a97f"}[chunkId] + ".js";
};